import { UploadIcon } from 'shared/Icon/components/UploadIcon';
import { MicIcon } from 'shared/Icon/components/MicIcon';
import { AnchorLogoIcon } from './AnchorLogoIcon/index';
import AnchorPayIcon from './AnchorPayIcon/index';
import ArrowIcon from './ArrowIcon/index';
import CheckmarkIcon from './CheckmarkIcon/index';
import CircularArrowIcon from './CircularArrowIcon/index';
import { ClockIcon } from './ClockIcon/index';
import DollarSignIcon from './DollarSignIcon/index';
import { DownloadIcon } from './DownloadIcon/index';
import ExternalLinkIcon from './ExternalLinkIcon/index';
import EyeDropperIcon from './EyeDropperIcon/index';
import { GearIcon } from './GearIcon/index';
import InfoIcon from './InfoIcon/index';
import JustifiedIcon from './JustifiedIcon/index';
import { LockIcon } from './LockIcon/index';
import MagnifyingGlassIcon from './MagnifyingGlassIcon/index';
import MicrophoneIcon from './MicrophoneIcon/index';
import { OptionDotsIcon } from './OptionDotsIcon/index';
import { PauseIcon } from './PauseIcon/index';
import { PencilIcon } from './PencilIcon';
import PlayIcon from './PlayIcon/index';
import { PowerIcon } from './PowerIcon/index';
import QuestionMarkIcon from './QuestionMarkIcon/index';
import QuoteIcon from './QuoteIcon/index';
import ReRecordIcon from './ReRecordIcon/index';
import { TrashIcon } from './TrashIcon/index';
import { UpsidedownTriangleIcon } from './UpsidedownTriangleIcon/index';
import { VideoPlayerIcon } from './VideoPlayerIcon';
import { VoiceMessageIcon } from './VoiceMessageIcon';
import { GlobeIcon } from '../../../components/svgs/GlobeIcon';
import XIcon from './XIcon/index';

export default {
  AnchorLogoIcon,
  AnchorPayIcon,
  ArrowIcon,
  CheckmarkIcon,
  CircularArrowIcon,
  ClockIcon,
  DollarSignIcon,
  DownloadIcon,
  ExternalLinkIcon,
  EyeDropperIcon,
  GearIcon,
  GlobeIcon,
  InfoIcon,
  JustifiedIcon,
  LockIcon,
  MagnifyingGlassIcon,
  MicIcon,
  MicrophoneIcon,
  OptionDotsIcon,
  PauseIcon,
  PencilIcon,
  PlayIcon,
  PowerIcon,
  QuestionMarkIcon,
  QuoteIcon,
  ReRecordIcon,
  TrashIcon,
  UploadIcon,
  UpsidedownTriangleIcon,
  VideoPlayerIcon,
  VoiceMessageIcon,
  XIcon,
};
